function UploadStatusBar({ status }) {
  if (status.state === "idle") return null;
  if (status.state === "error") {
    return <div
      role="alert"
      className="rounded-lg border border-[rgba(244,63,94,.4)] bg-[rgba(244,63,94,.14)] px-3 py-2 text-sm text-[#ffc9cd]"
    >
        <strong className="font-medium">{status.name}</strong> — {status.message}
      </div>;
  }
  const pct = status.state === "done" ? 100 : status.pct;
  const label = status.state === "done" ? "Uploaded and saved" : status.state === "preparing" ? "Optimising image\u2026" : "Uploading\u2026";
  return <div className="rounded-lg border border-[rgba(233,168,242,.22)] bg-white/[0.03] px-3 py-2">
      <div className="flex items-center justify-between text-[0.72rem]">
        <span className="truncate text-[#dcdff0]">
          {label} <span className="text-[color:var(--muted-foreground)]">· {status.name}</span>
        </span>
        <span className="ml-2 shrink-0 tabular-nums text-[#e9a8f2]">{pct}%</span>
      </div>
      <div className="mt-1.5 h-[3px] overflow-hidden rounded-full bg-white/10">
        <div
    className="h-full rounded-full transition-[width] duration-300"
    style={{ width: `${pct}%`, background: "linear-gradient(90deg,#9b6fd6,#e9a8f2)" }}
  />
      </div>
    </div>;
}
export {
  UploadStatusBar
};
